import React from "react";

const QuantityStepper = ({ value, disabled, max = 99, onChange }) => (
  <div className="sy-cart-qty">
    <button
      type="button"
      className="sy-cart-qty-btn"
      aria-label="Decrease quantity"
      disabled={disabled || value <= 1}
      onClick={() => onChange(value - 1)}
    >
      <svg viewBox="0 0 20 20" aria-hidden="true">
        <path d="M5 10h10" />
      </svg>
    </button>

    <span className="sy-cart-qty-value" aria-live="polite">
      {value}
    </span>

    <button
      type="button"
      className="sy-cart-qty-btn"
      aria-label="Increase quantity"
      disabled={disabled || value >= max}
      onClick={() => onChange(value + 1)}
    >
      <svg viewBox="0 0 20 20" aria-hidden="true">
        <path d="M10 5v10M5 10h10" />
      </svg>
    </button>
  </div>
);

export default QuantityStepper;
